import userStore from "./userStore";
import tenantsStore from "./tenantsStore";
import repairPagesStore from "./repairPagesStore";
import tenantsChooseStore from "./tenantsChooseStore";



const stores = {
  userStore,
  tenantsStore,
  repairPagesStore,
  tenantsChooseStore,
};

export {
  userStore,
  tenantsStore,
  repairPagesStore,
  tenantsChooseStore,
};

export default stores;

